// extracted by mini-css-extract-plugin
export default {"content":"AboutCard_content__R5+SO","card":"AboutCard_card__q5kyp","text":"AboutCard_text__MPJ99"};